import React, { useEffect, useState } from "react";
import Context from "./index";

const BookingProvider = (props) => {
  const emptyCallback = async () => {
    return null;
  };
  const [bookingObj, setBookingObj] = useState({});
  const [bookingObjs, setBookingObjs] = useState({});

  const [bookingEditType, setBookingEditType] = useState(null);
  const [bookingEditTypes, setBookingEditTypes] = useState(null);

  const [editBookCabModal, setEditBookCabModal] = useState(false);
  const [editRebookBookCabModal, setEditRebookBookCabModal] = useState(false);
  const [onSubmitData, setOnSubmitData] = useState(() => {
    return {
      fetchBookingData: emptyCallback,
    };
  });   
  const toggleBookCabModal = () => {
    if(editBookCabModal){
      setBookingObj({})
      setBookingEditType(null)
    }
    setEditBookCabModal(!editBookCabModal);
  }     
  const toggleeditCabModal = () => {
    if(editRebookBookCabModal){
      setBookingObjs({})
      setBookingEditTypes(null)
    }
   
    setEditRebookBookCabModal(!editRebookBookCabModal);
  }

  return (
    <Context.Provider
      value={{
        ...props,
        toggleBookCabModal: toggleBookCabModal,
        bookingObj,
        editBookCabModal,
        bookingEditType,
        onSubmitData: onSubmitData,
        setBookingObj,
        setBookingEditType,
        setEditBookCabModal,
        setOnSubmitData,
        emptyCallback:emptyCallback,
        // ----
        toggleeditCabModal,editRebookBookCabModal,
        bookingObjs, setBookingObjs,bookingEditTypes, setBookingEditTypes
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default BookingProvider;
